// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1YBlZ","inputDescription":"styles_inputDescription__1SOAG"};